import net from "../Assets/svg/icon/net.svg";

export const superPricingMenuItems = [{
    id: 5,
    menu_title: "periods",
    menu_icon: net,
    active: true,
    path: "/admin/pricing/periods",
},{
    id: 4,
    menu_title: "factors",
    menu_icon: net,
    active: true,
    path: "/admin/pricing/factors",
},{
    id: 3,
    menu_title: "products",
    menu_icon: net,
    active: true,
    path: "/admin/pricing/products",
},{
    id: 2,
    menu_title: "services",
    menu_icon: net,
    active: true,
    path: "/admin/pricing/services",
},{
    id: 1,
    menu_title: "supervisor",
    menu_icon: net,
    active: true,
    path: "/admin/pricing/supervisor",
}]